import { Box1, Box2, Box3 } from "../../general_assets/containers"
import "../../App.css"
import { useEffect, useState } from "react"
import { useLocation } from 'react-router-dom'
import rest from "../../utils/rest"

export function Sys_MainPage() {

    const [consoleState, setConsoleState] = useState({
        console: "Loading Data", 
        warnings: "Loading Warnings", 
        errors: "Loading Errors"
    })

    const location = useLocation();

    useEffect(() => {
        GetConsoleLoop();
        const interval = setInterval(() => {
            GetConsoleLoop();
        }, 5000);

        return () => clearInterval(interval)
    }, [])

    //TODO: add some sort of mutex lock
    function GetConsoleLoop(){
        rest.JSONRequest('', 'GET', {}, {}).then((response) => {
            if(response.status != 200) {
                setConsoleState({
                    console: "Failed to load data\n retrying in 5 seconds", 
                    warnings: "Failed to load warnings", 
                    errors: "Failed to load errors"
                })
            }
            setConsoleState(response.data)
        })
    }

    return (
        <div className='main_page flex'>
            <div className="h-stack">
                <Box1 title="Console">
                    <p className="text"> {consoleState.console} </p>
                </Box1>
                <div className="v-stack">
                    <div className="h-stack">
                        <Box3 title="Warnings">
                            <p className="text"> {consoleState.warnings} </p>
                        </Box3>
                        <Box3 title="Errors">
                            <p className="text"> {consoleState.errors} </p>
                        </Box3>
                    </div>
                    <Box3 title="Stats">

                    </Box3>
                </div>
            </div>
        </div>
    )
}